import React, { useState } from "react"
import MetaTags from "react-meta-tags"
import {
    Card,
    CardBody,
    Col,
    Container,
    Row,
    TabContent,
    TabPane,
    ListGroup,
    ListGroupItem
} from "reactstrap"
import classnames from "classnames"
import Breadcrumbs from "components/Common/Breadcrumb"

// Sub-components
import SalaryComponent from "./settings/SalaryComponent"
import SalaryGroup from "./settings/SalaryGroup"
import SSF from "./settings/SSF"
import Bonus from "./settings/Bonus"
import SalaryTDS from "./settings/SalaryTDS"
import AdvanceSalary from "./settings/AdvanceSalary"
import OverTime from "./settings/OverTime"
import UnderTime from "./settings/UnderTime"
import PaymentMethod from "./settings/PaymentMethod"

const PayrollConfig = () => {
    const [activeTab, setActiveTab] = useState("1")

    const toggleTab = tab => {
        if (activeTab !== tab) setActiveTab(tab)
    }

    const pinkActiveStyle = { backgroundColor: "#ff3366", color: "#fff", borderColor: "#ff3366" }

    const navItems = [
        { id: "1", title: "Salary Component", component: <SalaryComponent /> },
        { id: "2", title: "Salary Group", component: <SalaryGroup /> },
        // { id: "3", title: "SSF", component: <SSF /> },
        // { id: "4", title: "Bonus", component: <Bonus /> },
        // { id: "5", title: "Salary TDS", component: <SalaryTDS /> },
        // { id: "6", title: "Advance Salary", component: <AdvanceSalary /> },
        // { id: "7", title: "OverTime", component: <OverTime /> },
        // { id: "8", title: "UnderTime", component: <UnderTime /> },
        // { id: "9", title: "Payment Method", component: <PaymentMethod /> },
    ]

    return (
        <React.Fragment>
            <div className="page-content">
                <MetaTags>
                    <title>Payroll Settings | HRMS</title>
                </MetaTags>
                <Container fluid>
                    <Breadcrumbs title="HRMS" breadcrumbItem="Payroll Settings" />
                    <PayrollSettingsView activeTab={activeTab} toggleTab={toggleTab} navItems={navItems} pinkActiveStyle={pinkActiveStyle} />
                </Container>
            </div>
        </React.Fragment>
    )
}

// Separate component for the view so it can be reused in index.js
export const PayrollSettingsView = ({ activeTab, toggleTab, navItems, pinkActiveStyle }) => {
    return (
        <Row>
            <Col md={3} className="pe-0 border-end">
                <ListGroup flush>
                    {navItems.map(item => (
                        <ListGroupItem
                            key={item.id}
                            tag="button"
                            action
                            onClick={() => toggleTab(item.id)}
                            className={classnames({ "active": activeTab === item.id })}
                            style={activeTab === item.id ? pinkActiveStyle : { border: "none", textAlign: "left", padding: "12px 20px" }}
                        >
                            {item.title}
                        </ListGroupItem>
                    ))}
                </ListGroup>
            </Col>

            <Col md={9} className="ps-3 pt-2">
                <TabContent activeTab={activeTab}>
                    {navItems.map(item => (
                        <TabPane key={item.id} tabId={item.id}>
                            {activeTab === item.id && item.component}
                        </TabPane>
                    ))}
                </TabContent>
            </Col>
        </Row>
    )
}

export default PayrollConfig
